import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=40ab164b&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=40ab164b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ab164b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/dev-official-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40ab164b')) {
      api.createRecord('40ab164b', component.options)
    } else {
      api.reload('40ab164b', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=40ab164b&scoped=true", function () {
      api.rerender('40ab164b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Footer.vue"
export default component.exports